import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { TranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { API_BASE_URL, MASTER_POLICY_BASE_URL, authInterceptor } from 'vlife-common';

import { environment } from 'src/environments/environment';
import { routes } from './app.routes';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { MultiTranslateLoader } from './core/loaders/multi-translate.loader';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding(), withViewTransitions()),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideAnimationsAsync(),
    provideTranslateService({
      lang: 'id',
      fallbackLang: 'en',
      loader: {
        provide: TranslateLoader,
        useClass: MultiTranslateLoader,
      },
    }),
    { provide: API_BASE_URL,           useValue: environment.apiUrl           },
    { provide: MASTER_POLICY_BASE_URL, useValue: environment.masterPolicyApiUrl },
  ],
};
